module.exports = __webpack_public_path__ + "static/allelectronics-80745144444181d28e7a4fbddc9f4975.png";